type IconProps = { className?: string };

const baseProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export function BankIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M3 21h18M5 21V10M19 21V10M9 21v-8M15 21v-8M2 10l10-7 10 7" />
    </svg>
  );
}

export function ArrowDownLeftIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M17 7L7 17M7 7v10h10" />
    </svg>
  );
}

export function ArrowUpRightIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M7 17L17 7M7 7h10v10" />
    </svg>
  );
}

export function AdjustmentsIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M4 6h10M14 6h6M4 12h6M10 12h10M4 18h14M18 18h2" />
      <circle cx="14" cy="6" r="2" />
      <circle cx="10" cy="12" r="2" />
      <circle cx="18" cy="18" r="2" />
    </svg>
  );
}

export function ShieldIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z" />
    </svg>
  );
}

export function ChartIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M3 21h18M7 21V9M12 21V5M17 21v-8" />
    </svg>
  );
}

export function QuestionIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <path d="M12 17h.01" />
    </svg>
  );
}

export function ArrowLeftIcon({ className = 'h-5 w-5' }: IconProps) {
  return (
    <svg {...baseProps} className={className}>
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}
